import { Typography } from '@material-ui/core';
import React from 'react';
import { ArrowRight } from 'react-feather';
import styled from '../../styled';
import { COLORS } from '../../themes/color';
import { CtaButton } from '../CtaButton';
import { CustomerTypesSection } from '../CustomerTypesSection';
import { Headline } from '../Headline';
import { LogosSection } from '../LogosSection';
import { GradientBackground } from './GradientBackground';

const HeroSectionWrapper = styled('section')`
  position: relative;
  overflow: hidden;
  padding: 80px 0 0;
  display: flex;
  flex-direction: column;

  @media (max-width: 960px) {
    padding: 60px 0 0;
  }
`;

const HeroContentWrapper = styled('div')`
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 600px;

  @media (max-width: 960px) {
    min-height: auto;
  }
`;

const HeroWrapper = styled('div')`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

const LeftContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Description = styled(Typography)`
  font-size: 18px;
  line-height: 1.6;
  color: #4f4f4f;
  margin: 0;
` as typeof Typography;

const ButtonGroup = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const LearnMoreLink = styled('a')`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${COLORS.PRIMARY};
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const RightContent = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroImage = styled('img')`
  width: 100%;
  height: auto;
  max-width: 100%;
`;

export const HeroSection = ({ onGetStarted }: { onGetStarted: () => void }) => {
  return (
    <HeroSectionWrapper>
      <GradientBackground />
      <HeroContentWrapper>
        <HeroWrapper>
          <LeftContent>
            <Headline component="h1">
              The Commerce Growth Engine for Publishers and Brands
            </Headline>

            <Description component="p">
              Affilimate pairs advanced automation with affiliate data to drive
              revenue and maximize yield for premium publishers and leading
              brands.
            </Description>

            <ButtonGroup>
              <CtaButton size="medium" onClick={onGetStarted}>
                Get started today
              </CtaButton>
              <LearnMoreLink href="/#customer-types">
                Learn more <ArrowRight size={18} />
              </LearnMoreLink>
            </ButtonGroup>
          </LeftContent>

          <RightContent>
            <HeroImage src="/images/hero-right.png" alt="Dashboard preview" />
          </RightContent>
        </HeroWrapper>
      </HeroContentWrapper>
      <div style={{ position: 'relative', zIndex: 1 }}>
        <LogosSection />
        <CustomerTypesSection />
      </div>
    </HeroSectionWrapper>
  );
};
